/**
 * URL normalisation shared by the support-context buffers.
 *
 * Everything the client captures for a support request ends up in an email, so
 * URLs are reduced to their path first: query strings on this API carry
 * identifiers (record ids, emails, filter values) and the contract promises the
 * client strips them.
 */

/**
 * Reduce a URL to its path: no origin, no query string, no fragment.
 *
 * String operations rather than `new URL` because callers pass both absolute
 * URLs and root-relative paths, and `new URL` throws on the latter without a
 * base.
 */
export function toPathOnly(url: string): string {
  const withoutQuery = url.split(/[?#]/)[0];
  const withoutOrigin = withoutQuery.replace(/^[a-z][\w+.-]*:\/\/[^/]*/i, '');

  return withoutOrigin || '/';
}
